import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const PolandFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 513 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_103_9095)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M512.5 512H0.5V0H512.5V512Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M512.5 512H0.5V256H512.5V512Z"
        fill="#DC143C"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_9095">
        <rect
          width="512"
          height="512"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
